export default __webpack_public_path__ + "static/media/city.c9143038.png";